import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

/**
 * Улучшенный компонент аккордеона специально для страницы NewOrder
 * Решает проблемы с анимацией, состоянием и стилизацией
 */
const NewOrderAccordion = ({ 
  title, 
  content, 
  defaultOpen = false,
  isCurrentDay = false,
  dayName = '',
  onToggle,
  className = ''
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  
  // Синхронизация с внешним состоянием, если передан onToggle
  useEffect(() => {
    if (onToggle && typeof onToggle === 'function') {
      // Внешнее управление состоянием
      return;
    }
  }, [onToggle]);

  const handleToggle = () => {
    const newState = !isOpen;
    setIsOpen(newState);
    
    // Вызываем внешний обработчик, если есть
    if (onToggle && typeof onToggle === 'function') {
      onToggle(dayName, newState);
    }
  };

  return (
    <div className={`new-order-accordion ${isOpen ? 'is-open' : ''} ${isCurrentDay ? 'current-day' : ''} ${className}`}>
      <motion.div
        className={`new-order-accordion-header ${isOpen ? 'open' : ''}`}
        onClick={handleToggle}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => e.key === 'Enter' && handleToggle()}
        whileHover={{ scale: 1.005 }}
        whileTap={{ scale: 0.995 }}
        transition={{ type: "spring", stiffness: 400, damping: 17 }}
      >
        <div className="accordion-title-content">
          {title}
        </div>
        <motion.div 
          className="accordion-icon"
          animate={{ rotate: isOpen ? 180 : 0 }}
          transition={{ duration: 0.2, ease: "easeInOut" }}
        >
          <svg 
            width="20" 
            height="20" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="currentColor" 
            strokeWidth="2"
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
          </svg>
        </motion.div>
      </motion.div>
      
      <AnimatePresence>
        {isOpen && (
          <motion.div
            className="new-order-accordion-body"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ 
              height: { duration: 0.3, ease: "easeInOut" },
              opacity: { duration: 0.2, ease: "easeInOut" }
            }}
          >
            <div className="accordion-content-wrapper">
              {content}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default NewOrderAccordion;